import RecommendationsReceivedModal from './RecommendationsReceivedModal';
export default RecommendationsReceivedModal;